module.exports = __webpack_public_path__ + "static/media/menu1.a450cc10.svg";